
import Updates from "../Components/Common/Updates";
import Ads from "../Components/FirstComponents/Ads";
import Videos from "../Components/Common/Videos";
import { useEffect, useState } from "react";
import ListboxSelect from "../Utils/ListboxSelect";
import Banner from "../Utils/Banner";

function LatestUpdates() {
  const [contents, setContents] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState({
    id: 0,
    name: "All",
  });
  const [subCategories, setSubCategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState({
    id: 0,
    name: "All",
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    const callContents = async () => {
      try {
        const res = await fetch(
          process.env.REACT_APP_BASE_API_URL +
            "/contents?content_category_id=4",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            // credentials: "include",
          }
        );

        const data = await res.json();
        const list = Array.isArray(data) ? data : [];
        // Newest first — frontend only, API order is unchanged
        const sorted = [...list].sort((a, b) => {
          const dateA = new Date(a.createdAt || a.updatedAt || 0).getTime();
          const dateB = new Date(b.createdAt || b.updatedAt || 0).getTime();
          return dateB - dateA;
        });
        setContents(sorted);
        if (!res.status === 200) {
          const error = new Error(res.error);
          throw error;
        }
      } catch (err) {
        console.log(err);
      }
    };
    callContents();
  }, []);

  useEffect(() => {
    const callLanguages = async () => {
      try {
        const res = await fetch(
          process.env.REACT_APP_BASE_API_URL + "/languages",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            // credentials: "include",
          }
        );

        const data = await res.json();
        console.log(data);
        const all = { id: 0, name: "All" };
        data.unshift(all);
        setLanguages(data);
        console.log(languages);
        if (!res.status === 200) {
          const error = new Error(res.error);
          throw error;
        }
      } catch (err) {
        console.log(err);
      }
    };
    callLanguages();

    const callSubCategories = async () => {
      try {
        const res = await fetch(
          process.env.REACT_APP_BASE_API_URL + "/content-subcategories",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            // credentials: "include",
          }
        );

        const data = await res.json();
        console.log(data);
        const all = { id: 0, name: "All" };
        data.unshift(all);
        setSubCategories(data);

        if (!res.status === 200) {
          const error = new Error(res.error);
          throw error;
        }
      } catch (err) {
        console.log(err);
      }
    };
    callSubCategories();
  }, []);

  return (
    <>
      <div
        className="bg-gray-200 bg-no-repeat bg-contain "
        style={{
          backgroundImage: "url('/assets/background.png')",
          backgroundPosition: "right top",
        }}
      >
        <div className="mx-auto ">
          <Banner title="Latest Updates" imageUrl="/assets/Second_Banner.png" />

          <span className="flex justify-end gap-2 m-10">
            <ListboxSelect
              label={"All Languages"}
              items={languages}
              onSelect={setSelectedLanguage}
            />
            {/* <ListboxSelect
              label='All Sub Categories'
              items={subCategories}
              onSelect={setSelectedSubCategory}
            /> */}
          </span>

          <div className="mx-auto ml-4 mr-4 md:ml-6 md:mr-6 lg:mr-14 lg:ml-14 xl:ml-32 xl:mr-32">
            <Videos
              contents={contents}
              subCategory={selectedSubCategory}
              language={selectedLanguage}
              buttonText={"Read more"}
            />
            <Ads />
            {/* <Subscribe /> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default LatestUpdates;
